// assets/custom-section-crossfade.js

document.addEventListener('DOMContentLoaded', () => {
  // この属性が付いたセクションだけ対象にする
  const sections = document.querySelectorAll('.section[data-cf-section="true"]');

  sections.forEach((section) => {
    const cfHost = section.querySelector('.cf-host');
    if (!cfHost) return;

    const imgs = cfHost.querySelectorAll('img');
    if (!imgs.length) return;

    // 背景用ラッパーを作る
    const bgHost = document.createElement('div');
    bgHost.className = 'cf-bg-host';
    section.appendChild(bgHost);

    // 画像からスライドを作成
    imgs.forEach((img) => {
      const src = img.currentSrc || img.src;
      if (!src) return;

      const slide = document.createElement('div');
      slide.className = 'cf-bg-slide';
      slide.style.backgroundImage = `url("${src}")`;
      bgHost.appendChild(slide);

      // 元画像は非表示用のクラスだけ付けておく
      img.classList.add('cf-hidden-img');
    });

    const slides = bgHost.querySelectorAll('.cf-bg-slide');
    if (!slides.length) return;

    let currentIndex = 0;
    slides[currentIndex].classList.add('is-active');

    // 4秒ごとにフェード（必要なら値だけ変えてOK）
    const interval = 8000;

    if (slides.length > 1) {
      setInterval(() => {
        slides[currentIndex].classList.remove('is-active');
        currentIndex = (currentIndex + 1) % slides.length;
        slides[currentIndex].classList.add('is-active');
      }, interval);
    }
  });
});
